/**
 * Fill `{name}` placeholders of a translated template. Values are plain strings (React escapes
 * them when rendered); an unknown placeholder stays as written, so a missing value is visible.
 */
export function fillTemplate(template: string, values: Readonly<Record<string, string | number>>): string {
  return template.replace(/\{([a-zA-Z]+)\}/g, (match, name: string) =>
    Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match,
  );
}
